module.exports = __webpack_public_path__ + "assets/images/carSeat-01.db6ed2a729c8ca43a76902561bd1475b.svg";